import { request } from './request';

export interface Credentials {
  username: string;
  password: string;
}

export interface Token {
  access_token: number;
  expires_in: number;
  iat: number;
  jti: number;
  refresh_token: number;
  scope: string;
  token_type: string;
}

export const authenticate = (credentials: Credentials) =>
  request<Token>('/gateway/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
    headers: { 'Content-Type': 'application/json' },
  });
